import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";

const STEPS = [
  ["Scan", "Enter your URL. We fetch your live site and companion files."],
  ["Score", "Receive your AI Revenue Readiness Score across six categories."],
  ["Diagnose", "See exactly where AI systems may encounter friction."],
  ["Choose", "Receive the implementation plan recommended for your business."],
  ["We Implement", "Our autonomous implementation system performs authorized fixes."],
  ["We Test", "Every relevant capability is independently re-tested by QA."],
  ["Get Verified", "Qualifying businesses receive AgenticReady Verified™."],
  ["Stay Ready", "Continuous monitoring detects breakage and new opportunities."],
];

export default function HowItWorks() {
  const navigate = useNavigate();
  return (
    <div>
      <section className="bg-slate-950 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight">From Traditional Website to Agentic Ready.</h1>
          <p className="mt-4 text-slate-300 max-w-2xl">A standardized, mostly-autonomous process. No discovery call. No kickoff meeting. Human interaction is an exception, not the funnel.</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="relative border-l-2 border-slate-200 ml-4 space-y-8">
          {STEPS.map(([t, d], i) => (
            <div key={t} className="relative pl-8">
              <div className="absolute -left-[17px] top-0 h-8 w-8 rounded-full bg-indigo-600 text-white flex items-center justify-center font-heading font-bold text-sm">{i + 1}</div>
              <h3 className="font-heading text-lg font-semibold text-slate-900">{t}</h3>
              <p className="text-slate-600 mt-1">{d}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-12"><Button onClick={() => navigate("/free-scan")} className="h-12 px-7 rounded-full bg-indigo-600 hover:bg-indigo-700 font-semibold" data-testid="how-page-cta">Get My Free Score</Button></div>
      </section>
    </div>
  );
}
